<div class="cf-main-container" style="max-height: calc(100vh - 180px); overflow: auto;">
    <owc-card class="cf-one-card">
        <owc-component-header style="padding: 0px">
            <span class="owc-title">Configure feedback form</span>
             <owc-switch [(ngModel)]="feedbackEnabled" (ngModelChange)="updateFBEnabled($event)" style="right: 5px; position: relative;">
                Enabled
            </owc-switch>
       </owc-component-header>
       <div>
         <p *ngIf="feedbackEnabled">Click on "Add feedback option" to add a new feedback option</p>
       </div>
        <div *ngIf="!feedbackEnabled">
            The notification will not collect feedback and no Confirm button will be shown to the customer contact.
        </div>

        <div *ngIf="feedbackEnabled" class="mat-card-content">
            <dl-cf-feedback-template  [isNewFromTemplate]="isNewFromTemplate" [addRowData]="updateFeedbackOptions" [displayedColumns]="templateColumn" [tableData]="templateData" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (feedbackAddedChange)="onFeedbackAdded($event)" (hasUnsavedChanges)="onUnsavedChanges($event)" #temp></dl-cf-feedback-template>          
        </div>
        <div class="mat-card-actions">
            <owc-component-footer style="margin-top: 40px;">
            <owc-button style="display:none;" (click)="btnTemplatesClicked()" [disabled]="ischeckforTemplate" mat-stroked-button one-secondary-button>
                Templates
            </owc-button>          
            <div class="cf-dropdown-button">
                <div *ngIf="isAfoBtnExpanded">
                    <owc-button (click)="newFeedbackClicked('clicked')" mat-list-item style="width: 100%; height: auto;">New</owc-button>
                    <owc-divider></owc-divider>
                    <owc-button style="display: none;" (click)="chooseFromTemplateClicked()" [disabled]="ischeckforTemplate">Choose from templates</owc-button>
                    <owc-divider></owc-divider>
                </div>
                <owc-button *ngIf="feedbackEnabled" (click)="btnAfoClicked()" [disabled]="isAfoBtnDisabled" [class.btn-expanded]="isAfoBtnExpanded" class="btn-add-feedback" mat-stroked-button one-secondary-button>
                    <span>Add feedback option</span>
                </owc-button>
            </div>
        </owc-component-footer>
        </div>
       
    </owc-card>
    
</div>
